/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImageMetadata } from './ImageMetadata';
import {
    ImageMetadataFromJSON,
    ImageMetadataFromJSONTyped,
    ImageMetadataToJSON,
    ImageMetadataToJSONTyped,
} from './ImageMetadata';
import type { PriorContext } from './PriorContext';
import {
    PriorContextFromJSON,
    PriorContextFromJSONTyped,
    PriorContextToJSON,
    PriorContextToJSONTyped,
} from './PriorContext';
import type { SpeciesCandidate } from './SpeciesCandidate';
import {
    SpeciesCandidateFromJSON,
    SpeciesCandidateFromJSONTyped,
    SpeciesCandidateToJSON,
    SpeciesCandidateToJSONTyped,
} from './SpeciesCandidate';

/**
 * Everything the caller knows that might help the model judge size.
 * Serialized (None fields dropped) as the prompt's JSON context object.
 * @export
 * @interface EstimateContext
 */
export interface EstimateContext {
    /**
     * 
     */
    source: string;
    /**
     * 
     */
    speciesCandidates?: Array<SpeciesCandidate> | null;
    /**
     * 
     */
    senderMessage?: string | null;
    /**
     * 
     */
    speciesHint?: string | null;
    /**
     * 
     */
    notes?: string | null;
    /**
     * 
     */
    priors?: PriorContext | null;
    /**
     * 
     */
    imageMetadata?: ImageMetadata | null;
}

/**
 * Check if a given object implements the EstimateContext interface.
 */
export function instanceOfEstimateContext(value: object): value is EstimateContext {
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function EstimateContextFromJSON(json: any): EstimateContext {
    return EstimateContextFromJSONTyped(json, false);
}

export function EstimateContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateContext {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'],
        'speciesCandidates': json['species_candidates'] === undefined ? undefined : json['species_candidates'] === null ? null : ((json['species_candidates'] as Array<any>).map(SpeciesCandidateFromJSON)),
        'senderMessage': json['sender_message'] === undefined ? undefined : json['sender_message'] === null ? null : json['sender_message'],
        'speciesHint': json['species_hint'] === undefined ? undefined : json['species_hint'] === null ? null : json['species_hint'],
        'notes': json['notes'] === undefined ? undefined : json['notes'] === null ? null : json['notes'],
        'priors': json['priors'] === undefined ? undefined : json['priors'] === null ? null : PriorContextFromJSON(json['priors']),
        'imageMetadata': json['image_metadata'] === undefined ? undefined : json['image_metadata'] === null ? null : ImageMetadataFromJSON(json['image_metadata']),
    };
}

export function EstimateContextToJSON(json: any): EstimateContext {
    return EstimateContextToJSONTyped(json, false);
}

export function EstimateContextToJSONTyped(value?: EstimateContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': value['source'],
        'species_candidates': value['speciesCandidates'] == null ? undefined : ((value['speciesCandidates'] as Array<any>).map(SpeciesCandidateToJSON)),
        'sender_message': value['senderMessage'],
        'species_hint': value['speciesHint'],
        'notes': value['notes'],
        'priors': PriorContextToJSON(value['priors']),
        'image_metadata': ImageMetadataToJSON(value['imageMetadata']),
    };
}

